import React, { useState } from 'react';
import { faqData } from '../../../mocks/faq';

export const FAQSection: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 text-center mb-12">
          Часто задаваемые вопросы
        </h2>

        <div className="space-y-4">
          {faqData.map((item, index) => (
            <div
              key={item.id}
              className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer hover:bg-gray-50 transition-colors"
              >
                <span className="text-lg font-bold text-gray-900 pr-4">{item.question}</span>
                <i
                  className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-2xl text-gray-600 flex-shrink-0 transition-transform`}
                ></i>
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-5 text-gray-700 leading-relaxed animate-fadeIn">
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};